import React from 'react';
import { useTranslation } from 'react-i18next';
import LogoContainer from './LogoContainer';
import { XIcon } from '../../../SVG';
import { WidgetStateChangeType, WidgetStates } from '../Widget';
import { useRingStyle } from '../../../tailwind_common/util';
import { THEME } from '../../../clearstep/util/Theme';
import { WIDGET_NAMESPACE } from '../../../../util/i18n/constants';
import { useTranslationService } from '../../../../util/i18n/TranslationServiceProvider';
var Text = function (_a) {
    var _b;
    var displayInitialGreeting = _a.displayInitialGreeting;
    var tService = useTranslationService().tService;
    var t = useTranslation().t;
    var params = new URLSearchParams(window.location.search);
    var customParamGreetingText = params.get('widgetGreetingText');
    if (customParamGreetingText && customParamGreetingText !== '') {
        return (React.createElement(React.Fragment, null, tService(customParamGreetingText, {
            ns: WIDGET_NAMESPACE,
        })));
    }
    if ((_b = THEME.widgetCustomizations) === null || _b === void 0 ? void 0 : _b.greetingText) {
        return (React.createElement(React.Fragment, null, tService(THEME.widgetCustomizations.greetingText, {
            ns: WIDGET_NAMESPACE,
        })));
    }
    if (displayInitialGreeting) {
        return (React.createElement(React.Fragment, null, t('widget.collapsedGreeting.initial', 'Hi there. Can we help you find care today?')));
    }
    return React.createElement(React.Fragment, null, t('widget.collapsedGreeting.returning', 'Welcome back. Can we help you find care?'));
};
export var CollapsedGreeting = function (_a) {
    var setWidgetState = _a.setWidgetState, displayInitialGreeting = _a.displayInitialGreeting, iconPath = _a.iconPath;
    var ringStyle = useRingStyle();
    return (React.createElement("div", { className: "animate-widget-fade-in" },
        iconPath && (React.createElement(LogoContainer, { sizeClasses: "h-12 w-12", className: "absolute left-1/2 h-12 w-12 translate-x-[-50%] translate-y-[-50%]", iconPath: iconPath })),
        React.createElement("div", { className: "box-border flex w-full justify-end px-2 pt-2" },
            React.createElement("button", { onClick: function () { return setWidgetState(WidgetStates.HIDDEN, WidgetStateChangeType.MANUAL); }, className: "tw-focus p-1", style: ringStyle },
                React.createElement(XIcon, { stroke: "#9CA3AF" }))),
        React.createElement("button", { className: "tw-focus mb-4 ml-4 mr-5", style: ringStyle, onClick: function () { return setWidgetState(WidgetStates.EXPANDED, WidgetStateChangeType.MANUAL); } },
            React.createElement("div", { className: "h-[48px] overflow-auto text-left text-lg leading-[24px] text-black" },
                React.createElement(Text, { displayInitialGreeting: displayInitialGreeting })))));
};
export default CollapsedGreeting;
